import { render, staticRenderFns } from "./EFG-Footer-Module.vue?vue&type=template&id=2439057a&"
import script from "./EFG-Footer-Module.vue?vue&type=script&lang=js&"
export * from "./EFG-Footer-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports